import { Stack } from '@workramp/ui';
import { Component } from 'react';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import { academyCustomCSS } from '~/constants/academyCustomCSS';
import AcademyCertificationContentItem from './academy-certification-content-item';
import AcademyCertificationLearnerContentItem from './academy-certification-learner-content-item';

export default class AcademyCertificationContentList extends Component {
  render() {
    const {
      renderDots,
      content,
      onDeleteClick,
      isEditing,
      isPath,
      hasSequentialUnlock,
      themeOptions,
      academyId,
      openRecertificationModal,
      canRecertify,
      pageSlug,
    } = this.props;

    const SortableItem = SortableElement((props) => {
      const { isEditing, row } = props;

      return isEditing ? (
        <AcademyCertificationContentItem key={row.id} certificationContent={row} {...props} />
      ) : (
        <AcademyCertificationLearnerContentItem
          key={row.id}
          certificationContent={row}
          renderDots={renderDots}
          themeOptions={themeOptions}
          academyId={academyId}
          canRecertify={canRecertify}
          pageSlug={pageSlug}
          {...props}
        />
      );
    });

    const SortableList = SortableContainer((props) => {
      const { items, hasSequentialUnlock } = props;

      return (
        <Stack size={4} role="list" className={academyCustomCSS.overview.moduleBoxes}>
          {items.map((row, index) => {
            // Sequential unlock requires items to be completed in order
            let isLocked = false;
            if (hasSequentialUnlock) {
              // First item is always unlocked
              if (index > 0) {
                // Unlock item only if ALL previous items have been completed and passed
                const previousItems = items.slice(0, index);
                isLocked = !previousItems.every(
                  (item) =>
                    (item.contentType === 'academy_event' && item.attended === true) ||
                    (item.assignment?.completedAt && item.assignment?.passStatusMetadata?.didPass === true),
                );
              }

              // Unlock if current item was already completed
              if (items[index].assignment?.completedAt) {
                isLocked = false;
              }
            }

            return (
              <SortableItem
                key={`item-${index}`}
                index={index}
                row={row}
                lastItem={items.length === index + 1}
                isLocked={isLocked}
                {...props}
              />
            );
          })}
        </Stack>
      );
    });

    return (
      <SortableList
        items={content}
        onSortEnd={this.onSortEnd}
        onDeleteClick={onDeleteClick}
        useDragHandle
        isEditing={isEditing}
        isPath={isPath}
        hasSequentialUnlock={hasSequentialUnlock}
        openRecertificationModal={openRecertificationModal}
      />
    );
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const newOrderedCertContents = arrayMove(this.props.content, oldIndex, newIndex);
    const newOrderedCertContentIds = newOrderedCertContents.map((q) => q.id);
    this.props.handleResort(newOrderedCertContentIds);
  };
}
